import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { en } from './lang';
var placeholderRegex = /(\{[\d|\w]+\})/;
/**
 * Format the passed string replacing the numbered or tokenized placeholders
 * eg. LocalizationTextLabel1: I'd like some {0} and {1}, or just {0}
 * eg. LocalizationTextLabel2: I'd like some {bread} and {butter}, or just {bread}
 * Use example:
 * eg. 1: formatString(LocalizationTextLabel1, 'apps', 'banana')
 * eg. 2: formatString(LocalizationTextLabel2, { bread: 'app', butter: 'egg' }
 *
*/

var formatString = function formatString(str) {
  for (var _len = arguments.length, valuesForPlaceholders = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    valuesForPlaceholders[_key - 1] = arguments[_key];
  }

  var hasObject = false;
  var res = (str || '').split(placeholderRegex).filter(function (textPart) {
    return !!textPart;
  }).map(function (textPart, index) {
    if (textPart.match(placeholderRegex)) {
      var matchedKey = textPart.slice(1, -1);
      var valueForPlaceholder = valuesForPlaceholders[matchedKey]; // If no value found, check if working with an object instead

      if (valueForPlaceholder == undefined) {
        var _valuesForPlaceholder;

        var valueFromObjectPlaceholder = valuesForPlaceholders === null || valuesForPlaceholders === void 0 ? void 0 : (_valuesForPlaceholder = valuesForPlaceholders[0]) === null || _valuesForPlaceholder === void 0 ? void 0 : _valuesForPlaceholder[matchedKey];

        if (valueFromObjectPlaceholder !== undefined) {
          valueForPlaceholder = valueFromObjectPlaceholder;
        } else {
          // If value still isn't found, then it must have been undefined/null
          return valueForPlaceholder;
        }
      }

      if ( /*#__PURE__*/React.isValidElement(valueForPlaceholder)) {
        hasObject = true; // eslint-disable-next-line @typescript-eslint/ban-types

        return React.Children.toArray(valueForPlaceholder).map(function (component) {
          return _objectSpread(_objectSpread({}, component), {}, {
            key: index.toString()
          });
        });
      }

      return valueForPlaceholder;
    }

    return textPart;
  }); // If the results contains a object return an array otherwise return a string

  if (hasObject) return res;
  return res.join('');
};

var SFxLocalization = function SFxLocalization(strings, transFunc) {
  var _this = this;

  _classCallCheck(this, SFxLocalization);

  _defineProperty(this, "localizationStrings", void 0);

  _defineProperty(this, "translateFunc", void 0);

  this.localizationStrings = _objectSpread(_objectSpread({}, en), strings) || en;

  this.translateFunc = function (stringKey) {
    var textPart = '';
    var key = stringKey && stringKey.trim();

    if (typeof transFunc === "function") {
      textPart = transFunc(key) || _this.localizationStrings[key] || key;
    } else {
      textPart = _this.localizationStrings[key] || key;
    }

    for (var _len2 = arguments.length, valuesForPlaceholders = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      valuesForPlaceholders[_key2 - 1] = arguments[_key2];
    }

    return formatString.apply(void 0, [textPart].concat(valuesForPlaceholders));
  };
};

export { SFxLocalization as default };

var SFxLocalizationGlobal = /*#__PURE__*/function (_SFxLocalization) {
  _inherits(SFxLocalizationGlobal, _SFxLocalization);

  var _super = _createSuper(SFxLocalizationGlobal);

  function SFxLocalizationGlobal() {
    var _this2;

    _classCallCheck(this, SFxLocalizationGlobal);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this2 = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this2), "setLocalizationStrings", function (strings) {
      _this2.localizationStrings = _objectSpread(_objectSpread({}, _this2.localizationStrings), strings);
    });

    _defineProperty(_assertThisInitialized(_this2), "setTranslateFunc", function (transFunc) {
      if (typeof transFunc === "function") {
        _this2.translateFunc = function (stringKey) {
          var key = stringKey && stringKey.trim();
          var textPart = transFunc(key) || _this2.localizationStrings[key] || key;

          for (var _len4 = arguments.length, valuesForPlaceholders = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
            valuesForPlaceholders[_key4 - 1] = arguments[_key4];
          }

          return formatString.apply(void 0, [textPart].concat(valuesForPlaceholders));
        };
      }
    });

    _defineProperty(_assertThisInitialized(_this2), "resetSetting", function () {
      _this2.localizationStrings = en;

      _this2.translateFunc = function (stringKey) {
        var key = stringKey && stringKey.trim();
        var textPart = _this2.localizationStrings[key] || key;

        for (var _len5 = arguments.length, valuesForPlaceholders = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
          valuesForPlaceholders[_key5 - 1] = arguments[_key5];
        }

        return formatString.apply(void 0, [textPart].concat(valuesForPlaceholders));
      };
    });

    return _this2;
  }

  return SFxLocalizationGlobal;
}(SFxLocalization);

export var SFxLocalizationUtil = new SFxLocalizationGlobal();
export var getTransFunc = function getTransFunc(localizationObj) {
  if (localizationObj && localizationObj instanceof SFxLocalization) {
    return localizationObj.translateFunc;
  }

  return SFxLocalizationUtil.translateFunc;
};